import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { getHasListingPublicationPublicUrl } from '../../../../../RentalPortalListing'
import {
  getTableRowQaProps,
  TableCellFreeSpaceFiller,
  useTableRowActions,
  useTableRowModClassName,
} from '../../../../../Table'

import { LISTING_PROFILE_PUBLISHINGS_ROW_ACTIONS_CONFIG } from './ListingProfilePublishingsRow.constants'
import {
  getIsListingPublicationRowActive,
  renderListingProfilePublishingsCell,
} from './ListingProfilePublishingsRow.utils'

import * as styles from './ListingProfilePublishingsRow.module.css'

function ListingProfilePublishingsRow({
  columns,
  emptyColumnSize,
  focusedRow,
  getArrowNavigationItemProps,
  getPublicationActions,
  index,
  isResizing,
  item,
  resizingColumn,
  showCellBorder,
  onCallAction,
  ...restProps
}) {
  const { t } = useTranslation()

  const { handleClick, handleMouseEnter, handleMouseLeave } =
    useTableRowActions(
      { item, ...restProps },
      LISTING_PROFILE_PUBLISHINGS_ROW_ACTIONS_CONFIG
    )

  const isLive = getHasListingPublicationPublicUrl(item)

  const actions = getPublicationActions(item)

  const className = useTableRowModClassName({
    className: classNames(styles.ListingProfilePublishingsRow, {
      [styles.static]: !isLive,
    }),
    isActive: getIsListingPublicationRowActive({ focusedRow, item }),
  })

  function handleCallAction(action) {
    onCallAction?.(action, item)
  }

  return (
    <div
      {...getTableRowQaProps()}
      {...getArrowNavigationItemProps?.(index)}
      className={className}
      onClick={isLive ? handleClick : undefined}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {columns.map(column => (
        <Fragment key={column.name}>
          {renderListingProfilePublishingsCell({
            actions,
            isActive: column.name === resizingColumn,
            isResizing,
            item,
            name: column.name,
            openAdLinkClassName: styles.openAdLink,
            scheduledTextClassName: styles.scheduledText,
            showCellBorder,
            t,
            width: column.width,
            onCallAction: handleCallAction,
          })}
        </Fragment>
      ))}
      <TableCellFreeSpaceFiller width={emptyColumnSize} />
    </div>
  )
}

export default ListingProfilePublishingsRow
